var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-container', {
    attrs: {
      "grid-list-sm": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "offset-sm3": ""
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l(this.scanItems, function (file, f_index) {
    return [_c('v-list-tile', {
      key: file.id,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function click($event) {
          return _vm.openDialog(file);
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "large": "",
        "color": "red"
      }
    }, [_vm._v("description")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(file.name)
      }
    }), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(file.created_at)
      }
    }), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(file.description)
      }
    })], 1), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "disabled": _vm.deletings.indexOf(file.id) > -1
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.deleteDialog(file);
        }
      }
    }, [_vm.deletings.indexOf(file.id) < 0 ? [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("delete")])] : [[_c('span', {
      staticClass: "custom-loader"
    }, [_c('v-icon', {
      attrs: {
        "light": ""
      }
    }, [_vm._v("mdi-cached")])], 1)]]], 2)], 1)], 1), f_index < _vm.scanItems.length - 1 ? _c('v-divider', {
      key: f_index
    }) : _vm._e()];
  })], 2)], 1)], 1)], 1), _c('v-dialog', {
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "description",
      "label": "Description"
    },
    model: {
      value: _vm.dialogFile.description,
      callback: function callback($$v) {
        _vm.$set(_vm.dialogFile, "description", $$v);
      },
      expression: "dialogFile.description"
    }
  })], 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "fab": "",
      "bottom": "",
      "left": "",
      "dark": ""
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "green",
      "fab": "",
      "bottom": "",
      "right": "",
      "dark": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.saveMedia();
      }
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1)], 1)], 1), _c('delete-dialog', {
    ref: "deleteDialog",
    attrs: {
      "preset": "delete"
    },
    on: {
      "deleted": _vm.deleteScanConfirmed
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }